import React from 'react';

export const Checkbox = ({
  label,
  isChecked,
  onChange,
  isReadOnly,
  isDisabled
}) => {

  return (
      <div className="row checkbox">
          <label>{label}</label>
          <input 
              type="checkbox" 
              checked={isChecked} 
              onChange={isReadOnly ? null : (e) => onChange(e.target.value)} 
              readOnly={isReadOnly}
              disabled={isDisabled}/>
          <span className="checkmark"></span>
      </div>
  )
}